/**
 * Initialize ArrayMapRegistry with templates for all entity types
 *
 * THIS FILE IS GENERATED — DO NOT EDIT
 * To regenerate, run make generate-practice-client from the repository root
 *
 * This should be called once during app startup, before Redux actions are dispatched.
 * It creates schema-initialized templates that can be efficiently cloned by reducers.
 */

import ArrayMapRegistry from './ArrayMapRegistry';

import AccountingConnection from '../entities/accountingConnection';
import ActivityCategory from '../entities/activityCategory';
import ActivityType from '../entities/activityType';
import Address from '../entities/address';
import Answer from '../entities/answer';
import BankAccount from '../entities/bankAccount';
import Blackout from '../entities/blackout';
import Calendar from '../entities/calendar';
import CalendarShare from '../entities/calendarShare';
import Campaign from '../entities/campaign';
import CaseType from '../entities/caseType';
import CaseTypeStage from '../entities/caseTypeStage';
import Category from '../entities/category';
import Comment from '../entities/comment';
import Conflict from '../entities/conflict';
import Contact from '../entities/contact';
import Court from '../entities/court';
import CourtDeadlineRule from '../entities/courtDeadlineRule';
import Deadline from '../entities/deadline';
import DeadlineRule from '../entities/deadlineRule';
import Discount from '../entities/discount';
import Docket from '../entities/docket';
import Document from '../entities/document';
import EntityTimestamp from '../entities/entityTimestamp';
import Event from '../entities/event';
import Expense from '../entities/expense';
import Firm from '../entities/firm';
import FlatFee from '../entities/flatFee';
import FlatFeeMilestone from '../entities/flatFeeMilestone';
import Group from '../entities/group';
import HolidayCalendar from '../entities/holidayCalendar';
import Identification from '../entities/identification';
import ImportExport from '../entities/importExport';
import ImportSource from '../entities/importSource';
import Invoice from '../entities/invoice';
import InvoiceBatch from '../entities/invoiceBatch';
import InvoiceBatchItem from '../entities/invoiceBatchItem';
import Lead from '../entities/lead';
import Lookup from '../entities/lookup';
import Matter from '../entities/matter';
import MatterStage from '../entities/matterStage';
import Milestone from '../entities/milestone';
import Option from '../entities/option';
import Participant from '../entities/participant';
import Privilege from '../entities/privilege';
import Question from '../entities/question';
import RedFlag from '../entities/redFlag';
import RedFlagType from '../entities/redFlagType';
import Referral from '../entities/referral';
import Resource from '../entities/resource';
import Role from '../entities/role';
import Task from '../entities/task';
import TaskSeries from '../entities/taskSeries';
import TemplateTask from '../entities/templateTask';
import TimeOff from '../entities/timeOff';
import Transaction from '../entities/transaction';
import User from '../entities/user';

const ENTITY_TYPES = [
    { clazz: AccountingConnection, name: 'accountingConnection' },
    { clazz: ActivityCategory, name: 'activityCategory' },
    { clazz: ActivityType, name: 'activityType' },
    { clazz: Address, name: 'address' },
    { clazz: Answer, name: 'answer' },
    { clazz: BankAccount, name: 'bankAccount' },
    { clazz: Blackout, name: 'blackout' },
    { clazz: Calendar, name: 'calendar' },
    { clazz: CalendarShare, name: 'calendarShare' },
    { clazz: Campaign, name: 'campaign' },
    { clazz: CaseType, name: 'caseType' },
    { clazz: CaseTypeStage, name: 'caseTypeStage' },
    { clazz: Category, name: 'category' },
    { clazz: Comment, name: 'comment' },
    { clazz: Conflict, name: 'conflict' },
    { clazz: Contact, name: 'contact' },
    { clazz: Court, name: 'court' },
    { clazz: CourtDeadlineRule, name: 'courtDeadlineRule' },
    { clazz: Deadline, name: 'deadline' },
    { clazz: DeadlineRule, name: 'deadlineRule' },
    { clazz: Discount, name: 'discount' },
    { clazz: Docket, name: 'docket' },
    { clazz: Document, name: 'document' },
    { clazz: EntityTimestamp, name: 'entityTimestamp' },
    { clazz: Event, name: 'event' },
    { clazz: Expense, name: 'expense' },
    { clazz: Firm, name: 'firm' },
    { clazz: FlatFee, name: 'flatFee' },
    { clazz: FlatFeeMilestone, name: 'flatFeeMilestone' },
    { clazz: Group, name: 'group' },
    { clazz: HolidayCalendar, name: 'holidayCalendar' },
    { clazz: Identification, name: 'identification' },
    { clazz: ImportExport, name: 'importExport' },
    { clazz: ImportSource, name: 'importSource' },
    { clazz: Invoice, name: 'invoice' },
    { clazz: InvoiceBatch, name: 'invoiceBatch' },
    { clazz: InvoiceBatchItem, name: 'invoiceBatchItem' },
    { clazz: Lead, name: 'lead' },
    { clazz: Lookup, name: 'lookup' },
    { clazz: Matter, name: 'matter' },
    { clazz: MatterStage, name: 'matterStage' },
    { clazz: Milestone, name: 'milestone' },
    { clazz: Option, name: 'option' },
    { clazz: Participant, name: 'participant' },
    { clazz: Privilege, name: 'privilege' },
    { clazz: Question, name: 'question' },
    { clazz: RedFlag, name: 'redFlag' },
    { clazz: RedFlagType, name: 'redFlagType' },
    { clazz: Referral, name: 'referral' },
    { clazz: Resource, name: 'resource' },
    { clazz: Role, name: 'role' },
    { clazz: Task, name: 'task' },
    { clazz: TaskSeries, name: 'taskSeries' },
    { clazz: TemplateTask, name: 'templateTask' },
    { clazz: TimeOff, name: 'timeOff' },
    { clazz: Transaction, name: 'transaction' },
    { clazz: User, name: 'user' },
];

export function initializeArrayMapRegistry(): void {
    ENTITY_TYPES.forEach((entity) => {
        try {
            const schema = entity.clazz.getSchema();
            ArrayMapRegistry.register(entity.name, schema);
        } catch (e) {
            console.error(`Failed to initialize ArrayMap template for ${entity.name}:`, e);
        }
    });
}
